// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {logEvent, getAnalytics} from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAphrdY3FRKiUlhUYTjh3b6FW5okXh1OsI",
    authDomain: "diwi-print.firebaseapp.com",
    databaseURL: "https://diwi-print-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "diwi-print",
    storageBucket: "diwi-print.firebasestorage.app",
    messagingSenderId: "202406043489",
    appId: "1:202406043489:web:1b1145d144535ad127ef20",
    measurementId: "G-EBXY473XZ5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const logGAEvent = (event, object) => {
    logEvent(analytics, event, object)
};

// const analytics = getAnalytics(app);
export default app;
